module.exports = __webpack_public_path__ + "static/media/ecil.0b908934.jpeg";